
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 17h4a5 5 0 005-5v-1h1a3 3 0 000-6h-1V4a1 1 0 00-1-1H5a1 1 0 00-1 1v8a5 5 0 005 5zm9-10h1a1 1 0 110 2h-1V7zM6 5h10v7a3 3 0 01-3 3H9a3 3 0 01-3-3V5zm15 14H3a1 1 0 000 2h18a1 1 0 000-2z","fill":"#A6B7D4"}})])
          )
        }
      }
    